import React, { useEffect, useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AppSettings } from './../../../config/app-settings.js';
import axiosClient from '../../../config/axios.js';
import Swal from 'sweetalert2';
//import { useJsApiLoader } from '@react-google-maps/api'; // Activar cuando se habilite la ubicación


import { useAuth } from '../../../context/AuthContext';


function Login() {
	const { login } = useAuth();

	const context = useContext(AppSettings);
	const [credentials, saveCredentials] = useState({});
	const [redirect, setRedirect] = useState(false);

	// const allowedCoordinates = JSON.parse(process.env.REACT_APP_ALLOWED_COORDINATES || '[]');
	// const allowAllCoordinates = process.env.REACT_APP_ALLOW_ALL_COORDINATES === 'TRUE';
	// const maxDistanceMeters = 10;

	// const { isLoaded } = useJsApiLoader({
	// 	googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
	// 	libraries: ['geometry'],
	// });

	// //Descomentar esta funcion cuando se active la restriccion de ubicacion
	// const handleLogin = async (e) => {
	// 	e.preventDefault();
	// 	//console.log("Coordenadas permitidas:", allowedCoordinates);

	// 	if (
	// 	!isLoaded ||
	// 	!window.google ||
	// 	!window.google.maps ||
	// 	!window.google.maps.geometry
	// 	) {
	// 	Swal.fire({
	// 		title: "Error",
	// 		text: "Google Maps API no está lista. Intenta recargar la página.",
	// 		icon: "error",
	// 		confirmButtonText: "Cerrar",
	// 	});
	// 	return;
	// 	}

	// 	navigator.geolocation.getCurrentPosition(
	// 	async (position) => {
	// 		const { latitude, longitude, accuracy } = position.coords;
	// 		console.log(
	// 		`Mi ubicación actual : Latitud: ${latitude}, Longitud: ${longitude}, Precisión estimada: ${accuracy} metros`
	// 		);

	// 		const userLatLng = new window.google.maps.LatLng(latitude, longitude);
	// 		if (!allowAllCoordinates) {
	// 		const isAllowed = allowedCoordinates.some((coord) => {
	// 			// Convierte cada coordenada permitida a LatLng
	// 			const allowedLatLng = new window.google.maps.LatLng(
	// 			coord.lat,
	// 			coord.lng
	// 			);
	// 			// Calcula la distancia en metros entre la ubicación actual y la coordenada permitida
	// 			const distance =
	// 			window.google.maps.geometry.spherical.computeDistanceBetween(
	// 				userLatLng,
	// 				allowedLatLng
	// 			);
	// 			console.log(
	// 			`Distancia a punto permitido: ${distance.toFixed(2)} metros`
	// 			);
	// 			return distance <= maxDistanceMeters;
	// 		});

	// 			//if (!isAllowed) {
	// 			if (false) {
	// 			Swal.fire({
	// 			title: "Fuera de ubicación permitida",
	// 			text: "No puedes iniciar sesión desde esta ubicación.",
	// 			icon: "error",
	// 			confirmButtonText: "Cerrar",
	// 			});
	// 			return;
	// 		}
	// 		} else {
	// 		console.log(
	// 			"ALLOW_ALL_COORDINATES está activado. Se omite validación por ubicación."
	// 		);
	// 		}
	// 		try {
	// 		const response = await axiosClient.post("/login", credentials);
	// 		login(
	// 			response.data.response.token,
	// 			response.data.response.fullName,
	// 			response.data.response.userId,
	// 			response.data.response.username,
	// 			response.data.response.roles
	// 		);
	// 		setRedirect(true);
	// 		} catch (err) {
	// 		Swal.fire({
	// 			title: err.response?.data?.message || "Error al iniciar sesión",
	// 			icon: "error",
	// 			confirmButtonText: "Cerrar",
	// 		});
	// 		}
	// 	},
	// 	() => {
	// 		Swal.fire({
	// 		title: "Ubicación requerida",
	// 		text: "Debes permitir el acceso a tu ubicación para iniciar sesión.",
	// 		icon: "warning",
	// 		confirmButtonText: "Cerrar",
	// 		});
	// 	},
	// 	{ enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
	// 	);
  	// };

	//Comentar esta funcion cuando se active la restriccion de ubicacion
	const handleLogin = async e => {
		e.preventDefault();

		try {
			const response = await axiosClient.post('/login', credentials);

			login(response.data.response.token, response.data.response.fullName, response.data.response.userId, response.data.response.username, response.data.response.roles, response.data.response.roleMenus);
			setRedirect(true);
		} catch (err) {
			Swal.fire({
				title: err.response.data.message,
				text: null,
				icon: 'error',
				confirmButtonText: 'Cerrar',
				cancelButtonText: 'Cancelar',
				showCancelButton: false,
			});
		}
	}

	//Saving in state the field values
	const readData = e => {
		saveCredentials({
			...credentials,
			[e.target.name]: e.target.value
		})
	}

	useEffect(() => {
		context.handleSetAppHeaderNone(true);
		context.handleSetAppSidebarNone(true);
		context.handleSetAppContentClass('p-0');

		return function cleanUp() {
			context.handleSetAppHeaderNone(false);
			context.handleSetAppSidebarNone(false);
			context.handleSetAppContentClass('');
		};

		// eslint-disable-next-line
	}, []);

	// // Activar cuando se habilite la ubicación
	// if (!isLoaded) {
	// 	return <div>Cargando Google Maps...</div>;
	// }

	if (redirect) {
		return <Navigate to='/' />;
	}

	return (
		<div className="login login-v1">
			<div className="login-container">
				<div className="login-header">
					<div className="brand">
						<div className="d-flex align-items-center">
							<span className="logo"></span> <b>Grúas</b>  Varo
						</div>
						<small>Sistema de Administración</small>
					</div>
					<div className="icon">
						<i className="fa fa-lock"></i>
					</div>
				</div>
				<div className="login-body">
					<div className="login-content fs-13px">
						<form onSubmit={handleLogin}>
							<div className="form-floating mb-20px">
								<input type="text" className="form-control fs-13px h-45px" id="emailAddress" name="username" placeholder="Usuario" onChange={readData} />
								<label htmlFor="emailAddress" className="d-flex align-items-center py-0">Usuario</label>
							</div>
							<div className="form-floating mb-20px">
								<input type="password" className="form-control fs-13px h-45px" id="password" name="password" placeholder="Contraseña" onChange={readData} />
								<label htmlFor="password" className="d-flex align-items-center py-0">Contraseña</label>
							</div>
							<div className="form-check mb-20px">
								<input className="form-check-input" type="checkbox" value="" id="rememberMe" />
								<label className="form-check-label" htmlFor="rememberMe">
									Recordarme
								</label>
							</div>
							<div className="login-buttons">
								<button type="submit" className="btn h-45px btn-theme d-block w-100 btn-lg">Iniciar sesión</button>
							</div>
							<div className="form-floating mt-20px">
								Versión grúas: 1.5.10v
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Login;